import './style.scss';
import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import wlmLoader from './wlmloader03.gif';
import wlmOpaque from './wlmopaque.png';

class Loading extends Component {
	render() {
		return (
			<div className="wishlistmember-mergecodes-loading">
				<img src={wlmOpaque} />
				<img src={wlmLoader} />
			</div>
		);
	}
}

export default Loading;
